/**
 * Archivo generado por `npm run legal:generate`.
 * No editar: la fuente de verdad vive en `docs/legal/*.md`.
 */

import type { LegalDocSlug, LegalDocument } from './legal.model';

export const LEGAL_DOCS: Readonly<Record<LegalDocSlug, LegalDocument>> =
{
  "terminos-y-condiciones": {
    "slug": "terminos-y-condiciones",
    "title": "Términos y Condiciones de Uso",
    "lastUpdated": "1 de julio de 2026",
    "version": "1.0",
    "sections": [
      {
        "id": "identificacion-del-comerciante",
        "heading": "1. Identificación del comerciante",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Este sitio web y la tienda en línea <strong>Perrón Store</strong> (en adelante, \"la Tienda\", \"nosotros\") son operados por:"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": false,
              "items": [
                {
                  "spans": [
                    {
                      "text": "<strong>Nombre del comerciante:</strong> Omar Fernández Zúñiga"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Cédula física:</strong> 1-1442-0914"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Nombre comercial:</strong> Perrón Store"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Domicilio:</strong> Plaza Del Castillo, local 17, Zapote, San José, Costa Rica"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Correo de contacto:</strong> hola@perronstore.com"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Teléfono / WhatsApp:</strong> 8912-5220"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Sitio web:</strong> https://perronstore.com"
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "objeto-y-aceptacion",
        "heading": "2. Objeto y aceptación",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "La Tienda comercializa productos de juegos de cartas coleccionables (<em>Trading Card Games</em> o TCG) y artículos relacionados: cartas individuales (<em>singles</em>), producto sellado (sobres, cajas, mazos, sets), accesorios (fundas, tapetes, dados, portafolios), juegos de mesa y artículos en preventa o precompra."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Al navegar, registrarse o realizar una compra en este sitio, la persona usuaria (en adelante, \"el Cliente\") declara haber leído, entendido y aceptado estos Términos y Condiciones, así como la "
              },
              {
                "text": "Política de Privacidad",
                "to": "privacidad"
              },
              {
                "text": ", la "
              },
              {
                "text": "Política de Cambios y Devoluciones",
                "to": "cambios-y-devoluciones"
              },
              {
                "text": " y la "
              },
              {
                "text": "Política de Envíos",
                "to": "envios"
              },
              {
                "text": ". Si no está de acuerdo con alguno de estos términos, deberá abstenerse de utilizar el sitio."
              }
            ]
          }
        ]
      },
      {
        "id": "capacidad-legal-y-registro",
        "heading": "3. Capacidad legal y registro",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Para realizar compras, el Cliente debe ser mayor de edad (18 años) y tener capacidad legal para contratar. Las personas menores de edad solo podrán utilizar el sitio bajo la supervisión y responsabilidad de su padre, madre o representante legal."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El Cliente que cree una cuenta es responsable de la veracidad de los datos suministrados y de la custodia de sus credenciales de acceso. Cualquier actividad realizada desde su cuenta se presume efectuada por él."
              }
            ]
          }
        ]
      },
      {
        "id": "productos-disponibilidad-y-precios",
        "heading": "4. Productos, disponibilidad y precios",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Los precios se expresan en <strong>colones costarricenses (CRC)</strong> e incluyen el Impuesto al Valor Agregado (IVA) vigente, salvo que se indique lo contrario."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Las imágenes son ilustrativas. En el caso de cartas individuales, la condición (estado), idioma, rareza y tipo de acabado (<em>non-foil</em>, <em>foil</em>, etc.) se describen en cada ficha de producto."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "La disponibilidad de inventario es limitada. La Tienda procura mantener el <em>stock</em> actualizado, pero puede ocurrir que un producto figure como disponible y se agote. En tal caso, se contactará al Cliente para ofrecer una alternativa, un <em>backorder</em> o el reembolso correspondiente."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "La Tienda se reserva el derecho de modificar precios y catálogo en cualquier momento. El precio aplicable es el vigente al momento de confirmar el pedido."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Errores evidentes de precio:</strong> si por error tipográfico o de sistema un producto se publica a un precio manifiestamente equivocado, la Tienda podrá cancelar el pedido afectado e informar al Cliente, reintegrando cualquier monto cobrado."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "proceso-de-compra",
        "heading": "5. Proceso de compra",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "El Cliente selecciona los productos, los agrega al carrito y confirma el pedido siguiendo los pasos indicados en el sitio."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "El pedido constituye una oferta de compra que se perfecciona cuando la Tienda confirma su aceptación y, en su caso, se acredita el pago."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "La Tienda enviará una confirmación del pedido al correo registrado. Conserve dicha confirmación como comprobante."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "medios-de-pago",
        "heading": "6. Medios de pago",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "La Tienda pone a disposición del Cliente los medios de pago que se indiquen como disponibles en el sitio al momento de la compra, que pueden incluir:"
                    }
                  ],
                  "sublist": {
                    "ordered": false,
                    "items": [
                      {
                        "spans": [
                          {
                            "text": "<strong>SINPE Móvil</strong> al número 8912-5220."
                          }
                        ]
                      },
                      {
                        "spans": [
                          {
                            "text": "<strong>Transferencia bancaria</strong> a la cuenta de BAC Credomatic CR59010200009506738891, a nombre de Omar Fernández Zúñiga."
                          }
                        ]
                      },
                      {
                        "spans": [
                          {
                            "text": "*<em>Apartado (</em>layaway<em>):</em>* pago en abonos, sujeto a las condiciones de la sección 7."
                          }
                        ]
                      },
                      {
                        "spans": [
                          {
                            "text": "<strong>Pago con tarjeta:</strong> cuando esté habilitado, se procesará a través de la pasarela de pago <strong>ONVO Pay</strong>. La Tienda <strong>no almacena</strong> los datos completos de su tarjeta; estos son gestionados de forma segura, bajo estándares de la industria, por el proveedor de pagos."
                          }
                        ]
                      }
                    ]
                  }
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Comprobante de pago.</strong> En los pagos por SINPE Móvil o transferencia, el Cliente debe <strong>enviar el comprobante</strong> por el medio indicado en el sitio (adjuntarlo al pedido o por WhatsApp 8912-5220). El pedido se confirma una vez <strong>verificado</strong> que el comprobante corresponde al pedido y al monto."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Si el comprobante <strong>no corresponde</strong>, no puede verificarse, o el pago con tarjeta es rechazado o queda pendiente, el pedido podrá quedar en espera o ser <strong>cancelado</strong>, liberándose el inventario reservado."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "apartado-layaway",
        "heading": "7. Apartado (*layaway*)",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Para los productos en los que se ofrezca esta modalidad, el <strong>apartado</strong> permite reservar el producto y pagarlo mediante <strong>abonos</strong> dentro de un plazo:"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "<strong>Abono inicial (enganche):</strong> 30 % del valor del pedido."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Plazo máximo para completar el pago:</strong> 30 días naturales."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "El producto se <strong>reserva</strong> a nombre del Cliente y se <strong>despacha una vez cancelado el total</strong>."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "La Tienda podrá enviar <strong>recordatorios</strong> de vencimiento (por WhatsApp u otro medio). Si al vencimiento el pago no se ha completado, la Tienda se comunicará con el Cliente; la cancelación del apartado <strong>no es automática</strong>."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Cancelación y abonos:</strong> en caso de cancelación del apartado o de incumplimiento del plazo, el <strong>abono inicial (enganche) del 30 % no es reembolsable</strong>. Cualquier monto abonado por encima del enganche se <strong>reintegra al Cliente</strong>."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "preventas-y-precompras",
        "heading": "8. Preventas y precompras",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Algunos productos se ofrecen en <strong>preventa/precompra</strong> antes de su fecha de lanzamiento oficial."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Las fechas de lanzamiento son estimadas y dependen del distribuidor o fabricante; pueden variar sin que ello genere responsabilidad para la Tienda más allá del derecho del Cliente a cancelar y ser reembolsado conforme a la "
                    },
                    {
                      "text": "Política de Cambios y Devoluciones",
                      "to": "cambios-y-devoluciones"
                    },
                    {
                      "text": "."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Las condiciones específicas de cobro, entrega y cancelación de cada preventa se detallan en la ficha del producto."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "derecho-de-retracto-compras-en-linea",
        "heading": "9. Derecho de retracto (compras en línea)",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "De conformidad con el artículo 40 de la Ley 7472 y su Reglamento, en las ventas a distancia el Cliente tiene derecho a rescindir la compra, sin responsabilidad y sin necesidad de justificación, dentro de los <strong>ocho (8) días hábiles</strong> siguientes al perfeccionamiento de la venta. El ejercicio de este derecho y la restitución de los importes se rigen por lo dispuesto en la "
              },
              {
                "text": "Política de Cambios y Devoluciones",
                "to": "cambios-y-devoluciones"
              },
              {
                "text": "."
              }
            ]
          }
        ]
      },
      {
        "id": "propiedad-intelectual",
        "heading": "10. Propiedad intelectual",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Las marcas, nombres de juegos, logotipos, ilustraciones y demás contenidos de cartas y productos son propiedad de sus respectivos titulares (fabricantes y editores). La Tienda los utiliza únicamente con fines de identificación y comercialización de producto legítimo."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "El diseño del sitio, los textos propios, la mascota de la Tienda y demás materiales creados por la Tienda están protegidos por derechos de autor y no pueden reproducirse sin autorización."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "conducta-del-usuario",
        "heading": "11. Conducta del usuario",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El Cliente se compromete a no utilizar el sitio para fines ilícitos, a no intentar vulnerar su seguridad, a no realizar pedidos fraudulentos y a no suplantar la identidad de terceros. La Tienda podrá suspender o cancelar cuentas y pedidos ante usos indebidos."
              }
            ]
          }
        ]
      },
      {
        "id": "limitacion-de-responsabilidad",
        "heading": "12. Limitación de responsabilidad",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "La Tienda no será responsable por interrupciones del servicio, errores técnicos, ni por daños derivados de causas fuera de su control razonable (caso fortuito o fuerza mayor)."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Nada en estos Términos limita los derechos irrenunciables que la legislación de protección al consumidor reconoce al Cliente."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "proteccion-de-datos-personales",
        "heading": "13. Protección de datos personales",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El tratamiento de los datos personales del Cliente se rige por la "
              },
              {
                "text": "Política de Privacidad",
                "to": "privacidad"
              },
              {
                "text": ", conforme a la Ley 8968 y la normativa de la Agencia de Protección de Datos de los Habitantes (PRODHAB)."
              }
            ]
          }
        ]
      },
      {
        "id": "modificaciones",
        "heading": "14. Modificaciones",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "La Tienda podrá actualizar estos Términos y Condiciones en cualquier momento. La versión vigente será la publicada en el sitio, con su fecha de actualización. El uso continuado del sitio tras una modificación implica la aceptación de la versión actualizada."
              }
            ]
          }
        ]
      },
      {
        "id": "legislacion-aplicable-y-resolucion-de-conflictos",
        "heading": "15. Legislación aplicable y resolución de conflictos",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Estos Términos se rigen por las leyes de la República de Costa Rica. Cualquier controversia se procurará resolver de buena fe; en su defecto, el Cliente podrá acudir a la Comisión Nacional del Consumidor del Ministerio de Economía, Industria y Comercio (MEIC) o a los tribunales costarricenses competentes."
              }
            ]
          }
        ]
      },
      {
        "id": "contacto",
        "heading": "16. Contacto",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Para consultas sobre estos Términos y Condiciones:"
              }
            ]
          },
          {
            "kind": "contact",
            "email": "hola@perronstore.com",
            "phone": "8912-5220",
            "hours": "Martes a domingo, de 12:00 p.m. a 7:00 p.m."
          }
        ]
      }
    ]
  },
  "privacidad": {
    "slug": "privacidad",
    "title": "Política de Privacidad",
    "lastUpdated": "3 de octubre de 2026",
    "version": "1.1",
    "sections": [
      {
        "id": "responsable-del-tratamiento",
        "heading": "1. Responsable del tratamiento",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El responsable de la base de datos y del tratamiento de los datos personales recolectados a través de <strong>Perrón Store</strong> es:"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": false,
              "items": [
                {
                  "spans": [
                    {
                      "text": "<strong>Nombre del comerciante:</strong> Omar Fernández Zúñiga"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Cédula física:</strong> 1-1442-0914"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Domicilio:</strong> Plaza Del Castillo, local 17, Zapote, San José, Costa Rica"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Correo de contacto en materia de datos:</strong> hola@perronstore.com"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Teléfono / WhatsApp:</strong> 8912-5220"
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "marco-legal",
        "heading": "2. Marco legal",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Esta Política se rige por la <strong>Ley N.º 8968</strong>, su Reglamento, y demás normativa emitida por la <strong>Agencia de Protección de Datos de los Habitantes (PRODHAB)</strong>, órgano adscrito al Ministerio de Justicia y Paz."
              }
            ]
          }
        ]
      },
      {
        "id": "datos-que-recolectamos",
        "heading": "3. Datos que recolectamos",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Recolectamos únicamente los datos necesarios para gestionar la relación comercial:"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": false,
              "items": [
                {
                  "spans": [
                    {
                      "text": "<strong>Datos de identificación y contacto:</strong> nombre, correo electrónico, número de teléfono."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Datos de entrega:</strong> dirección, provincia, cantón, distrito y señas para el envío."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Datos de la cuenta:</strong> usuario y contraseña (esta última se protege mediante un <em>hash</em> criptográfico no reversible)."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Datos de pedidos:</strong> historial de compras y preferencias."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Datos de la suscripción al boletín (opcional):</strong> si usted se suscribe a nuestro boletín, desde el formulario del sitio o desde la casilla del registro, tratamos su correo electrónico y conservamos, como prueba de su consentimiento, la fecha y hora, la dirección IP y el formulario desde el que se suscribió. La suscripción solo se activa cuando usted la confirma desde el correo de confirmación que le enviamos. Nuestro proveedor de envío del boletín (sección 6) registra además datos técnicos de cada envío, como entregas, aperturas, clics, rebotes y bajas, que utilizamos únicamente para gestionar y mejorar el boletín."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Datos de pago:</strong> para pagos por <strong>SINPE Móvil o transferencia</strong>, tratamos el <strong>comprobante de pago</strong> que usted nos envía con el fin de verificar la transacción y confirmar su pedido. Para pagos <strong>con tarjeta</strong> (cuando esté habilitado), estos son procesados por la pasarela <strong>ONVO Pay</strong>: <strong>no almacenamos los datos completos de su tarjeta</strong>; el procesador de pagos los gestiona de forma segura."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Datos de navegación y almacenamiento local:</strong> dirección IP; identificadores técnicos de sesión, autenticación y carrito; datos de contacto o entrega que el Cliente decida recordar; preferencias, búsquedas recientes y alertas de inventario almacenadas mediante localStorage o sessionStorage, conforme a la sección 8."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Datos del perfil de jugador (opcional):</strong> si usted activa su perfil en el directorio de jugadores, tratamos el alias público que elija, los juegos que seleccione, su provincia y cantón, una presentación breve, la forma de contacto que indique (WhatsApp, Discord, correo electrónico o «en la tienda») y el registro de las solicitudes para jugar que envíe o reciba, incluido el mensaje breve que las acompañe. Ver la sección 12."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "finalidades-del-tratamiento",
        "heading": "4. Finalidades del tratamiento",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Tratamos sus datos para:"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Procesar, gestionar y entregar sus pedidos."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Gestionar pagos, facturación, cambios, devoluciones y reembolsos."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Brindar soporte y atención al cliente."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Administrar su cuenta de usuario."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Enviarle comunicaciones sobre el estado de sus pedidos."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Con su consentimiento previo, enviarle promociones, novedades y boletines."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Cumplir obligaciones legales, contables y tributarias."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Si usted lo solicita, publicar su perfil en el directorio de jugadores y gestionar las solicitudes para jugar entre personas usuarias, conforme a la sección 12."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "base-de-legitimacion-y-consentimiento",
        "heading": "5. Base de legitimación y consentimiento",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El tratamiento se fundamenta en el consentimiento informado del Cliente, en la ejecución del contrato de compraventa y en el cumplimiento de obligaciones legales. Al registrarse o realizar una compra, el Cliente otorga su consentimiento para el tratamiento descrito en esta Política. El consentimiento para fines promocionales es <strong>opcional y revocable</strong> en cualquier momento."
              }
            ]
          }
        ]
      },
      {
        "id": "transferencia-a-terceros",
        "heading": "6. Transferencia a terceros",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "No vendemos ni alquilamos sus datos personales. Podemos compartirlos únicamente con:"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": false,
              "items": [
                {
                  "spans": [
                    {
                      "text": "<strong>Proveedor de pagos</strong> (ONVO Pay) para procesar los pagos con tarjeta, cuando este medio esté habilitado."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Proveedor de envío del boletín</strong> (Brevo, empresa con sede en Francia), únicamente si usted se suscribe al boletín: le comunicamos su correo electrónico para enviarle el correo de confirmación y, una vez confirmada la suscripción, los boletines y promociones. Brevo actúa como encargado del tratamiento y almacena los datos en servidores ubicados en la Unión Europea, por lo que este servicio implica una transferencia de su correo electrónico fuera de Costa Rica, que se realiza con el consentimiento que usted otorga al suscribirse. Puede darse de baja en cualquier momento mediante el enlace incluido en cada envío o escribiendo a hola@perronstore.com."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Empresas de mensajería y Correos de Costa Rica</strong> para realizar las entregas."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Proveedores tecnológicos</strong> (alojamiento web, correo) que actúan como encargados bajo deber de confidencialidad."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Autoridades competentes</strong>, cuando exista obligación legal."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "conservacion-de-los-datos",
        "heading": "7. Conservación de los datos",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Conservamos los datos durante el tiempo necesario para cumplir las finalidades indicadas y los plazos legales aplicables (por ejemplo, obligaciones tributarias y contables). Una vez cumplidos, los datos se eliminan o anonimizan de forma segura."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Los datos del perfil de jugador se conservan mientras el perfil exista. Al eliminar el perfil o la cuenta, se aplican las reglas de la sección 12."
              }
            ]
          }
        ]
      },
      {
        "id": "almacenamiento-local-y-tecnologias-similares",
        "heading": "8. Almacenamiento local y tecnologías similares",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El sitio utiliza principalmente localStorage y sessionStorage del navegador para mantener la sesión iniciada, recordar el carrito y conservar las preferencias o datos que el Cliente decida guardar en su dispositivo. Estos datos permanecen en el navegador hasta que el Cliente cierre la sesión, complete ciertas operaciones o los elimine desde la configuración del navegador. Al bloquear o borrar este almacenamiento, algunas funciones pueden reiniciarse o dejar de operar correctamente."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Los servicios indispensables integrados en el sitio, como la pasarela de pago, pueden utilizar sus propias <em>cookies</em> o tecnologías técnicas para prestar el servicio y proteger las transacciones. Si se incorporan <em>cookies</em> opcionales con fines analíticos o publicitarios, esta Política se actualizará y se solicitará el consentimiento correspondiente cuando la normativa lo requiera."
              }
            ]
          }
        ]
      },
      {
        "id": "derechos-de-la-persona-autodeterminacion-informativa",
        "heading": "9. Derechos de la persona (autodeterminación informativa)",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Conforme a la Ley 8968, el Cliente tiene derecho a <strong>acceder, rectificar, actualizar, suprimir</strong> sus datos y a <strong>revocar</strong> el consentimiento otorgado. Para ejercerlos, puede escribir a hola@perronstore.com indicando su solicitud; podremos requerir verificación de identidad. Responderemos en los plazos que establece la normativa. Si considera que sus derechos no han sido atendidos, puede acudir a la <strong>PRODHAB</strong>."
              }
            ]
          }
        ]
      },
      {
        "id": "seguridad",
        "heading": "10. Seguridad",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Aplicamos medidas técnicas y organizativas razonables para proteger los datos contra pérdida, acceso no autorizado o uso indebido (cifrado de contraseñas, conexiones seguras y control de accesos). Ningún sistema es completamente infalible, por lo que no podemos garantizar seguridad absoluta."
              }
            ]
          }
        ]
      },
      {
        "id": "menores-de-edad",
        "heading": "11. Menores de edad",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El sitio está dirigido a personas mayores de edad. No recolectamos conscientemente datos de menores sin el consentimiento de su representante legal. Si detectamos datos de un menor sin dicha autorización, procederemos a eliminarlos."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El directorio de jugadores (sección 12) exige, al activar el perfil, declarar que se tiene 18 años o más o que se cuenta con el permiso de la madre, el padre o la persona encargada. Precisamente por la posible participación de menores con autorización, el directorio nunca muestra nombres reales ni datos de contacto, y solo es visible para cuentas registradas y verificadas."
              }
            ]
          }
        ]
      },
      {
        "id": "directorio-de-jugadores-y-solicitudes-para-jugar",
        "heading": "12. Directorio de jugadores y solicitudes para jugar",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Perrón Store ofrece, de forma <strong>opcional</strong>, un directorio para que las personas usuarias encuentren con quién jugar. Ninguna de las funciones descritas en esta sección se activa sin una acción expresa de usted."
              }
            ]
          },
          {
            "kind": "subheading",
            "text": "12.1 Activación y consentimiento"
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El perfil de jugador se crea y se activa únicamente por decisión de usted, desde su cuenta, y requiere una cuenta con correo electrónico verificado. Al activarlo, le mostramos un texto de consentimiento que describe qué datos se harán visibles y a quién; conservamos la fecha y la versión del texto que usted aceptó como constancia de su consentimiento (Ley 8968). Puede desactivar el perfil o retirarlo del directorio en cualquier momento desde su cuenta, con efecto inmediato."
              }
            ]
          },
          {
            "kind": "subheading",
            "text": "12.2 Qué es visible y para quién"
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El directorio muestra únicamente: su <strong>alias público</strong> (nunca su nombre real), su <strong>provincia y cantón</strong>, los <strong>juegos</strong> que seleccionó, su <strong>presentación breve</strong> y la <strong>fecha desde la que figura en el directorio</strong>. Nunca muestra su nombre, apellidos, correo electrónico, teléfono, fotografía, forma de contacto ni indicadores de actividad."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El directorio <strong>solo es visible para personas con cuenta registrada y verificada</strong> en Perrón Store. No es accesible a visitantes anónimos ni está indexado por buscadores."
              }
            ]
          },
          {
            "kind": "subheading",
            "text": "12.3 Solicitudes para jugar y forma de contacto"
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Cualquier persona con perfil activo puede enviarle una solicitud para jugar, con un juego propuesto y un mensaje breve opcional. Usted decide si la acepta o la rechaza; quien la envió no recibe ningún correo del rechazo, aunque verá la solicitud como rechazada en su historial. Una solicitud sin respuesta caduca automáticamente a los 7 días."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Su <strong>forma de contacto</strong> (número de WhatsApp, usuario de Discord o correo electrónico de la cuenta) se comparte <strong>solo si usted acepta</strong> una solicitud, y solo con la otra persona de esa solicitud. En ese momento se guarda una copia de la forma de contacto de ambas partes tal como estaba al aceptar, cifrada en nuestra base de datos, y es esa copia la que se muestra. Cualquiera de las dos personas puede <strong>dejar de compartir el contacto</strong> en cualquier momento desde su cuenta; al hacerlo, ambas copias se eliminan y ninguna de las dos vuelve a ver el contacto de la otra. Si elige la opción «en la tienda», no se comparte ningún dato personal: la coordinación se hace presencialmente en Perrón Store."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Sus datos de contacto nunca aparecen en el directorio ni en los correos electrónicos que enviamos."
              }
            ]
          },
          {
            "kind": "subheading",
            "text": "12.4 Avisos por correo electrónico"
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Si tiene perfil activo, le enviaremos un aviso por correo electrónico cuando reciba solicitudes nuevas (como máximo uno cada seis horas, sin el contenido de los mensajes) y cuando alguien acepte una solicitud suya. Estos avisos no incluyen datos de contacto y puede desactivarlos desde su perfil en cualquier momento; el resto de comunicaciones sobre sus pedidos no se ve afectado."
              }
            ]
          },
          {
            "kind": "subheading",
            "text": "12.5 Medidas contra el uso indebido"
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Para proteger a las personas usuarias aplicamos límites al número de solicitudes que se pueden enviar y recibir, y no se permiten enlaces en los mensajes ni en la presentación. Perrón Store puede <strong>suspender</strong> un perfil de jugador ante un uso indebido o una denuncia fundada; un perfil suspendido deja de ser visible, no puede enviar ni aceptar solicitudes y sus datos de contacto dejan de mostrarse a otras personas. Si tiene algún problema con otro jugador, escríbanos por los medios de la sección 14."
              }
            ]
          },
          {
            "kind": "subheading",
            "text": "12.6 Eliminación y conservación"
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Puede <strong>eliminar su perfil de jugador</strong> en cualquier momento desde su cuenta. Al hacerlo se eliminan de forma definitiva el alias, los juegos, la zona, la presentación y la forma de contacto; las solicitudes pendientes en ambas direcciones se cancelan automáticamente sin aviso a la otra parte; se eliminan todas las copias de contacto asociadas a sus solicitudes y los mensajes que usted escribió. La eliminación de su cuenta de Perrón Store produce los mismos efectos sobre el perfil de jugador. El alias queda libre para otras personas."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Conservamos el registro de las solicitudes ya resueltas (estado, fechas y juego propuesto, sin contacto) como historial de su cuenta y para poder atender denuncias, durante el tiempo indicado en la sección 7. Los mensajes de las solicitudes cerradas se eliminan en un plazo máximo de 90 días desde su cierre."
              }
            ]
          }
        ]
      },
      {
        "id": "cambios-a-esta-politica",
        "heading": "13. Cambios a esta Política",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Podremos actualizar esta Política. La versión vigente, con su fecha, estará siempre publicada en el sitio. Cambios sustanciales se comunicarán por medios razonables."
              }
            ]
          }
        ]
      },
      {
        "id": "contacto",
        "heading": "14. Contacto",
        "blocks": [
          {
            "kind": "contact",
            "email": "hola@perronstore.com",
            "phone": "8912-5220",
            "hours": "Martes a domingo, de 12:00 p.m. a 7:00 p.m."
          }
        ]
      }
    ]
  },
  "cambios-y-devoluciones": {
    "slug": "cambios-y-devoluciones",
    "title": "Política de Cambios y Devoluciones",
    "lastUpdated": "1 de julio de 2026",
    "version": "1.0",
    "sections": [
      {
        "id": "compromiso",
        "heading": "1. Compromiso",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "En <strong>Perrón Store</strong> queremos que su compra sea una buena experiencia. Esta política explica cómo gestionamos los cambios, las devoluciones y los reembolsos, respetando los derechos que la legislación costarricense reconoce a las personas consumidoras."
              }
            ]
          }
        ]
      },
      {
        "id": "derecho-de-retracto-arrepentimiento-en-compras-en-linea",
        "heading": "2. Derecho de retracto (arrepentimiento) en compras en línea",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "De acuerdo con el artículo 40 de la Ley 7472 y su Reglamento, en las compras realizadas en línea usted puede <strong>rescindir la compra sin justificación y sin penalidad</strong> dentro de los <strong>ocho (8) días hábiles</strong> siguientes al perfeccionamiento de la venta."
              }
            ]
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "<strong>Cómo ejercerlo:</strong>"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Notifíquenoslo por el mismo medio por el que realizó la compra o escribiendo a hola@perronstore.com, indicando el número de pedido."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "El producto debe devolverse en el <strong>mismo estado</strong> en que lo recibió, sin uso y con su empaque y, en el caso de producto sellado, <strong>sin abrir</strong> (ver sección 4)."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Le restituiremos <strong>todos los importes recibidos</strong> dentro del plazo máximo de <strong>ocho (8) días naturales</strong>, por el mismo medio de pago que utilizó, contados a partir del día siguiente a la recepción del aviso o de la devolución del producto, según corresponda."
                    }
                  ]
                }
              ]
            }
          },
          {
            "kind": "note",
            "spans": [
              {
                "text": "El costo de envío de la devolución por retracto corre por cuenta del Cliente."
              }
            ]
          }
        ]
      },
      {
        "id": "productos-defectuosos-danados-o-incorrectos",
        "heading": "3. Productos defectuosos, dañados o incorrectos",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Si el producto llega <strong>defectuoso, dañado en el transporte o no corresponde</strong> con lo que pidió (por ejemplo, carta equivocada, condición distinta a la descrita, idioma o edición incorrectos):"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Contáctenos dentro de <strong>ocho (8) días naturales</strong> desde la recepción, con su número de pedido y <strong>fotografías</strong> del producto y del empaque."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Verificada la situación, podrá elegir entre: <strong>reposición</strong> del producto (sujeto a disponibilidad), <strong>cambio</strong> por otro de igual valor, o <strong>reembolso</strong> total."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "En estos casos, <strong>los costos de envío de la devolución y la reposición corren por cuenta de la Tienda.</strong>"
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "condiciones-por-tipo-de-producto",
        "heading": "4. Condiciones por tipo de producto",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Por la naturaleza de los juegos de cartas coleccionables, aplican condiciones específicas:"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": false,
              "items": [
                {
                  "spans": [
                    {
                      "text": "<strong>Producto sellado</strong> (sobres, cajas, mazos, <em>blisters</em>, sets): por tratarse de contenido aleatorio, solo se aceptan devoluciones si el producto está <strong>cerrado y sin abrir</strong>. No se aceptan devoluciones por inconformidad con el contenido aleatorio de los sobres o cajas abiertos."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "*<em>Cartas individuales (</em>singles<em>):<strong> se aceptan devoluciones cuando la carta </strong>no coincide</em>* con la condición, idioma, rareza o acabado descritos en la ficha. Dado que la condición es un atributo clave, recomendamos revisar la descripción y las fotos antes de comprar."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Accesorios y juegos de mesa:</strong> se aceptan devoluciones si están <strong>sin uso</strong>, en su empaque original y con todos sus componentes."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Productos en preventa/precompra:</strong> ver sección 5."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "preventas-precompras-y-apartados",
        "heading": "5. Preventas, precompras y apartados",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Puede <strong>cancelar</strong> una preventa o precompra y recibir el reembolso correspondiente <strong>antes</strong> de que el producto sea despachado."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Si la fecha de lanzamiento estimada se modifica de forma relevante, le informaremos y podrá optar por mantener el pedido o cancelarlo con reembolso."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Una vez despachado, aplican las condiciones generales de esta política según el tipo de producto."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "*<em>Apartado (</em>layaway<em>):<strong> si cancela un apartado antes de completar el pago, el </strong>abono inicial (enganche) del 30 % no es reembolsable<strong>; los montos abonados por encima del enganche se </strong>reintegran al Cliente</em>*. Las condiciones del apartado (abono inicial, plazo y vencimiento) se detallan en los "
                    },
                    {
                      "text": "Términos y Condiciones",
                      "to": "terminos-y-condiciones"
                    },
                    {
                      "text": "."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "productos-no-sujetos-a-cambio-o-devolucion",
        "heading": "6. Productos no sujetos a cambio o devolución",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Salvo defecto, daño o error de nuestra parte, y sin perjuicio del derecho de retracto de la sección 2, no se aceptan devoluciones de:"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": false,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Producto sellado <strong>abierto</strong> o con el precinto roto."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Cartas individuales que hayan sido <strong>usadas, jugadas o cuya condición se haya alterado</strong> estando en poder del Cliente."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Productos en oferta de liquidación marcados expresamente como <strong>\"venta final\"</strong>, que no admiten cambio ni devolución."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "procedimiento-general",
        "heading": "7. Procedimiento general",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Escriba a hola@perronstore.com o al WhatsApp 8912-5220 con su número de pedido y el motivo."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Le indicaremos cómo y a dónde remitir el producto (o coordinaremos el retiro, según el caso)."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Recibido y verificado el producto, gestionaremos el cambio, la reposición o el reembolso."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "reembolsos",
        "heading": "8. Reembolsos",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Los reembolsos se realizan, en la medida de lo posible, por el <strong>mismo medio de pago</strong> utilizado en la compra. En pagos por <strong>SINPE Móvil o transferencia</strong>, el reembolso se efectúa mediante devolución a la cuenta o número que el Cliente indique."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Para pagos <strong>con tarjeta</strong> procesados por ONVO Pay, el reembolso se tramita a través de la pasarela; el tiempo de acreditación puede depender del banco emisor."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Le notificaremos cuando el reembolso haya sido procesado."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "contacto",
        "heading": "9. Contacto",
        "blocks": [
          {
            "kind": "contact",
            "email": "hola@perronstore.com",
            "phone": "8912-5220",
            "hours": "Martes a domingo, de 12:00 p.m. a 7:00 p.m."
          },
          {
            "kind": "note",
            "spans": [
              {
                "text": "Si no obtiene una solución satisfactoria, puede acudir a la Comisión Nacional del Consumidor del MEIC."
              }
            ]
          }
        ]
      }
    ]
  },
  "envios": {
    "slug": "envios",
    "title": "Política de Envíos",
    "lastUpdated": "1 de julio de 2026",
    "version": "1.0",
    "sections": [
      {
        "id": "cobertura",
        "heading": "1. Cobertura",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "<strong>Perrón Store</strong> realiza envíos a todo el territorio de <strong>Costa Rica</strong>."
              }
            ]
          }
        ]
      },
      {
        "id": "medios-de-envio",
        "heading": "2. Medios de envío",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Ofrecemos distintos medios de entrega, según convenga a la zona y al pedido:"
              }
            ]
          },
          {
            "kind": "list",
            "list": {
              "ordered": false,
              "items": [
                {
                  "spans": [
                    {
                      "text": "<strong>Correos de Costa Rica.</strong>"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "*<em>Mensajería / </em>courier<em> privado.</em>*"
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Retiro en tienda:</strong> Plaza Del Castillo, local 17, Zapote, San José, sin costo de envío."
                    }
                  ]
                }
              ]
            }
          },
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "El medio disponible y su costo se muestran al Cliente durante el proceso de compra."
              }
            ]
          }
        ]
      },
      {
        "id": "costos-de-envio",
        "heading": "3. Costos de envío",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "El costo de envío se calcula según la zona de destino, el peso y las dimensiones del pedido, y se muestra al Cliente <strong>antes de confirmar el pago</strong>."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Las promociones de <strong>envío gratis</strong>, cuando apliquen, se indicarán en el sitio."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Los precios de envío se expresan en <strong>colones costarricenses (CRC)</strong>."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "plazos-de-entrega",
        "heading": "4. Plazos de entrega",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "<strong>Tiempo de preparación:</strong> los pedidos se procesan una vez confirmado el pago; el plazo estimado de preparación se indica en el sitio."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Tiempo de tránsito estimado:</strong> varía según la zona de destino (Gran Área Metropolitana y resto del país) y se indica al Cliente durante el proceso de compra."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Los plazos son <strong>estimados</strong> y pueden variar por factores ajenos a la Tienda (temporada alta, condiciones climáticas, disponibilidad del transportista o zonas de difícil acceso)."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "<strong>Productos en preventa/precompra:</strong> se despachan a partir de su fecha de lanzamiento; los plazos anteriores corren desde esa fecha."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "seguimiento-del-pedido",
        "heading": "5. Seguimiento del pedido",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Una vez despachado el pedido, le enviaremos a su correo la información de seguimiento (cuando el medio de envío lo permita) para que pueda dar seguimiento a su entrega."
              }
            ]
          }
        ]
      },
      {
        "id": "recepcion-del-pedido",
        "heading": "6. Recepción del pedido",
        "blocks": [
          {
            "kind": "list",
            "list": {
              "ordered": true,
              "items": [
                {
                  "spans": [
                    {
                      "text": "Asegúrese de proporcionar una <strong>dirección completa y correcta</strong> (provincia, cantón, distrito y señas). La Tienda no se hace responsable por retrasos o entregas fallidas debidas a datos incorrectos o incompletos."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Si no hay quien reciba el paquete, el transportista podrá reprogramar la entrega o dejar aviso, según sus políticas."
                    }
                  ]
                },
                {
                  "spans": [
                    {
                      "text": "Le recomendamos <strong>revisar el paquete al recibirlo</strong>. Si presenta daños visibles, indíquelo al transportista y contáctenos con fotografías (ver "
                    },
                    {
                      "text": "Política de Cambios y Devoluciones",
                      "to": "cambios-y-devoluciones"
                    },
                    {
                      "text": ")."
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        "id": "reenvios-y-devoluciones-por-entrega-fallida",
        "heading": "7. Reenvíos y devoluciones por entrega fallida",
        "blocks": [
          {
            "kind": "paragraph",
            "spans": [
              {
                "text": "Si un pedido es devuelto a la Tienda por causas atribuibles al Cliente (dirección incorrecta, ausencia reiterada o rechazo del paquete), se podrá coordinar un reenvío cuyo costo correrá por cuenta del Cliente."
              }
            ]
          }
        ]
      },
      {
        "id": "contacto",
        "heading": "8. Contacto",
        "blocks": [
          {
            "kind": "contact",
            "email": "hola@perronstore.com",
            "phone": "8912-5220",
            "hours": "Martes a domingo, de 12:00 p.m. a 7:00 p.m."
          }
        ]
      }
    ]
  }
};
